import React from "react";
import InputFormPresenter from "./InputFormPresenter";

const InputFormContainer = props => {
  return <InputFormPresenter {...props} />;
};

export default InputFormContainer;
